var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 3.5h10.792a.1.1 0 00.078-.162L9.5 1M11.5 6.5H.741a.1.1 0 00-.07.17L3 9",
    stroke: "#604DBC",
    strokeLinecap: "square"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNSAzLjVIMTEuMjkxOUMxMS4zNzU4IDMuNSAxMS40MjI0IDMuNDAzMDEgMTEuMzcgMy4zMzc1M0w5LjUgMSIgc3Ryb2tlPSIjNjA0REJDIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik0xMS41IDYuNUwwLjc0MTQyMiA2LjVDMC42NTIzMzIgNi41IDAuNjA3NzE0IDYuNjA3NzEgMC42NzA3MTEgNi42NzA3MUwzIDkiIHN0cm9rZT0iIzYwNERCQyIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8L3N2Zz4K";
export { SvgSwitch as ReactComponent };